<template>
  <div v-loading="loading">
    <div class="tips">
      <i class="el-icon-warning-outline"></i>
      <span
        >警示（并不温馨！）：供应商数据合并是将目前存在的两个或多个供应商合并到被保留供应商中。其中合并的数据包括：采购订单数据、询价数据、售后数据、财务收付款申请、申请的预付款、财务结算单、支付账号。
        （被合并的供应商信息将会被永久删除！！！）一旦提交合并，所涉及的供应商数据将无法再进行逆向恢复！被合并的供应商相关数据永久性删除！！！</span
      >
    </div>
    <el-row :gutter="20">
      <el-col :span="11"
        ><div class="grid-content">
          <el-card class="box-card">
            <div class="search-ctn">
              <div class="search-ctn-left">
                <div class="search-name">被保留的供应商</div>
                <el-select
                  class="search-item"
                  size="small"
                  style="width: 60%"
                  v-model="cusId"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  :remote-method="searchSupplier"
                  v-select-scroll-more="searchSupplierLoad"
                  @change="customerChange($event)"
                  @visible-change="supplierVisibleChange($event)"
                  placeholder="选择需要保留供应商"
                >
                    <el-option v-for="item in supplierList" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId" :data-msg="item">
                        <div class="name">
                            {{ item.EntpCusName }}
                            <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                        </div>
                    </el-option>                     
                </el-select>
              </div>
            </div>
            <div class="choose-item">
              <el-tag
                v-for="tag in cusTags"
                :key="tag.name"
                closable
                class="c-item"
                @close="closeCusTag(tag.id)"
              >
                {{ tag.name }}
              </el-tag>
            </div>
          </el-card>
        </div></el-col
      >
      <el-col :span="2"
        ><div class="grid-content imgcla">
          <img
            src="../../../assets/images/merge.png"
            alt
            class="link-icon"
          /></div
      ></el-col>
      <el-col :span="11"
        ><div class="grid-content">
          <el-card class="box-card">
            <div class="search-ctn">
              <div class="search-ctn-left">
                <div class="search-name">被合并的供应商</div>
                <el-select
                  class="search-item"
                  size="small"
                  style="width: 60%"
                  v-model="supId"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  allow-create
                  :remote-method="searchSupplier"
                  v-select-scroll-more="searchSupplierLoad"
                  @change="supplierChange($event)"
                  @visible-change="supplierVisibleChange($event)"
                  placeholder="选择被合并的供应商"
                >
                    <el-option v-for="item in supplierList" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusId" :data-msg="item">
                        <div class="name">
                            {{ item.EntpCusName }}
                            <span v-if="item.CallNum" class="phone">{{ ` ( 电话：${item.CallNum} )` }}</span>
                        </div>
                    </el-option>  
                </el-select>
              </div>
            </div>
            <div class="choose-item">
              <el-tag
                v-for="tag in supTags"
                :key="tag.name"
                closable
                type="success"
                class="c-item"
                @close="closeSupTag(tag.id)"
              >
                {{ tag.name }}
              </el-tag>
            </div>
          </el-card>
        </div></el-col
      >
    </el-row>
    <div class="dialog-footer">
      <div class="re-submit">
        <el-button class="btn-primary" @click="submitForm()"
          >提交合并</el-button
        >
        <el-button @click="cancel()">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: [],
  components: {},
  data() {
    return {
      loading: false,
      cusId: "",
      supId: "",
      sName: "",
      isEdit:false,
      supplierList: [],
      cusTags: [],
      supTags: [],
      submitData: {
        DelIds: [],
        KeepIds: [],
      },
      // 用于供应商列表，分页搜索
      supplierForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: '',
      },
    };
  },
  mounted() {
  },
  methods: {
    // 供应商列表，搜索
    async searchSupplier(key) {
      if (![undefined].includes(key)) {
        this.supplierForm.Page = 1
        this.supplierForm.stopLoad = false
        this.supplierForm.key = key
        this.supplierList = []
      }
      if (this.supplierForm.stopLoad) return
      const data = await this.$util.searchSupplier(
        this.supplierForm.key,
        this.supplierForm.Page,
        this.supplierForm.Limit
      )
      if (data) {
        if(!data)return;
        this.supplierForm.stopLoad = data.length < this.supplierForm.Limit
        this.supplierList = [
          ...this.supplierList,
          ...data
        ]
      }
    },
    // 供应商列表，加载更多
    searchSupplierLoad() {
      this.supplierForm.Page += 1
      this.searchSupplier()
    },
    submitForm() {
      if (this.cusTags.length < 1) {
        this.$util.warningMsg("请选择被保留供应商");
        return;
      }

      if (this.supTags.length < 1) {
        this.$util.warningMsg("请选择被合并的供应商");
        return;
      }

      this.$confirm(
        "您确认要提交供应商的数据进行合并吗？一旦合并将无法再进行恢复！",
        "提示",
        {
          confirmButtonText: "确定提交",
          cancelButtonText: "取消",
          type: "warning",
          center: false,
        }
      )
        .then(() => {
          this.loading = true;
          let keepIds = [];
          let delIds = [];
          if (this.cusTags.length > 0) {
            for (let index = 0; index < this.cusTags.length; index++) {
              keepIds.push(this.cusTags[index].id);
            }
          }
          if (this.supTags.length > 0) {
            for (let index = 0; index < this.supTags.length; index++) {
              delIds.push(this.supTags[index].id);
            }
          }
          
          this.submitData.DelIds = delIds;
          this.submitData.KeepIds = keepIds;
          this.$util
            .axiosPost({
              url: "/api/EntpSuppliers/SaveEntityMergeDatas",
              data: this.submitData,
              hideLoading: true,
            })
            .then((res) => {
              this.$util.successMsg(res.errmsg);
              this.isEdit = true;
              if (res.errcode === 0) this.clear();
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    cancel() {
      this.$emit("closeDialog",this.isEdit);
    },
    customerChange(value) {
      let that = this;
      let sup = that.supTags.find((e) => e.id == value);
      if (sup) {
        this.$util.warningMsg("被保留供应商与被合并供应商不能一样！");
        return;
      }
      let currCust = that.supplierList.find((e) => e.EntpCusId == value);
      if (currCust) {
        let EntpCusName = currCust.EntpCusName;
        let isHad = false;
        for (var i = 0; i < that.cusTags.length; i++) {
          if (this.cusTags[i].id === value) {
            isHad = true;
          }
        }
        if (!isHad) {
          that.cusTags = [];
          that.cusTags.push({ name: EntpCusName, id: value });
        }
      }
    },
    //当供应商下拉框出现时触发
    supplierVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.supplierList.length <= 1) that.searchSupplier('');
      }
    },
    supplierChange(value) {
      let that = this;
      let cus = that.cusTags.find((e) => e.id == value);
      if (cus) {
        this.$util.warningMsg("被保留供应商与被合并供应商不能具有相同项！");
        return;
      }
      let currCust = that.supplierList.find((e) => e.EntpCusId == value);
      if (currCust) {
        let EntpCusName = currCust.EntpCusName;
        let isHad = false;
        for (var i = 0; i < that.supTags.length; i++) {
          if (that.supTags[i].id === value) {
            isHad = true;
          }
        }
        if (!isHad) that.supTags.push({ name: EntpCusName, id: value });
      }

    },
    closeCusTag(val) {
      if (val) {
        for (var i = 0; i < this.cusTags.length; i++) {
          if (this.cusTags[i].id === val) {
            this.cusTags.splice(i, 1);
          }
        }
      }
    },
    closeSupTag(val) {
      if (val) {
        for (var i = 0; i < this.supTags.length; i++) {
          if (this.supTags[i].id === val) {
            this.supTags.splice(i, 1);
          }
        }
      }
    },
    clear() {
      this.cusId = "";
      this.supId = "";
      this.sName = "";
      this.supplierList = [];
      this.cusTags = [];
      this.supTags = [];
      this.submitData = {
        DelIds: [],
        KeepIds: [],
      };
      this.searchSupplier('');
    },
  },
};
</script>
<style lang="less" scoped>
.choose-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 5px;
  height: 250px;
  overflow-y: scroll;
}
.c-item {
  margin: 5px;
}
.grid-content {
  margin-bottom: 10px;
}
.imgcla {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
}
.link-icon {
  height: 50px;
  width: 50px;
  margin-left: 5px;
}
.box-card {
  height: 300px;
}
.re-submit {
  text-align: right;
}
.tips {
  color: #f00;
  margin-bottom: 8px;
  i {
    margin-right: 8px;
  }
}
</style>
